<template>
    <div>
        <Header></Header>
        <div class="activityCon">
            <div class="cover"></div>
        </div>
    </div>
</template>
<script>
import Header from '../../components/Header_M.vue'
export default{
  components:{
      Header
  }
}
</script>
<style scoped>
.activityCon{
    width: 100%;
    height: 100vh;
    background-color: #000;
    color: #fff;
    text-align: center;
    line-height: 100vh;
}
.activityCon .cover{
    width: inherit;
    height: inherit;
    background: transparent url('../../assets/stepinto_M.png') center no-repeat;
    background-size: 100%;
}
</style>


// WEBPACK FOOTER //
// src/view/mobile/Activity.vue